module.exports = require("react-immutable-pure-component");